import { useQuery } from '@tanstack/react-query';
import { fetchOverviewDashboard } from '../services/overviewService';

interface UseOverviewKpisParams {
  start_date: string;
  end_date: string;
}

export function useOverviewKpis(params: UseOverviewKpisParams) {
  const { start_date, end_date } = params;
  
  return useQuery({
    queryKey: ['overviewDashboard', params.start_date, params.end_date],
    queryFn: () => fetchOverviewDashboard(params),
    staleTime: 1000 * 60 * 5,
    enabled: !!start_date && !!end_date,
  });
}
